export enum EFilterOperator {
	isNull = '+null',
	isNotNull = '-null',
	isEqual = '+=',
	isNotEqual = '-=',
	isIn = '+in',
	isNotIn = '-in',
	isBetween = '+between',
	isNotBetween = '-between',
	isGt = '+>',
	isNotGt = '->',
	isGte = '+>=',
	isNotGte = '->=',
	isLt = '+<',
	isNotLt = '-<',
	isLte = '+<=',
	isNotLte = '-<=',
	isLike = '+ilike',
	isNotLike = '-ilike',
	isIntLike = '+like',
	isNotIntLike = '-like',
	isSubSet = '+@>',
	isNotSubSet = '-@>',
	isTrunc = '+trunc',
	isNotTrunc = '-trunc',
	isTruncMicrosecond = '+microsecond',
	isNotTruncMicrosecond = '-microsecond',
	isTruncMillisecond = '+millisecond',
	isNotTruncMillisecond = '-millisecond',
	isTruncSecond = '+second',
	isNotTruncSecond = '-second',
	isTruncMinute = '+minute',
	isNotTruncMinute = '-minute',
	isTruncHour = '+hour',
	isNotTruncHour = '-hour',
	isTruncDay = '+day',
	isNotTruncDay = '-day',
	isTruncWeek = '+week',
	isNotTruncWeek = '-week',
	isTruncMonth = '+month',
	isNotTruncMonth = '-month',
	isTruncQuarter = '+quarter',
	isNotTruncQuarter = '-quarter',
	isTruncYear = '+year',
	isNotTruncYear = '-year',
	isTruncDecade = '+decade',
	isNotTruncDecade = '-decade',
	isTruncCentury = '+century',
	isNotTruncCentury = '-century',
	isTruncMillenium = '+millenium',
	isNotTruncMillenium = '-millenium',
}